import React from "react";
import { Control, FieldErrors } from "react-hook-form";
import { FormDropdown, FormDropdownRules, mapToDropdownOption } from "sprint-common-web";

import { CLEAN_VIDEO_SUBTITLE_LANGUAGE_ID } from "../../../../common/api/master-api/common/consts";
import { useEmbeddedSubtitles } from "../../../../common/data/data-hooks/useEmbeddedSubtitles";
import { useCreateOrder } from "../common/provider/useCreateOrder";

interface OrderEmbeddedSubtitlesSelectorProps {
    label: string;
    name: string;
    control: Control;
    errors: FieldErrors;
    dependsOn: string[];
    testId?: string;
    rules?: FormDropdownRules;
}

export const OrderEmbeddedSubtitlesSelector = ({
    label,
    name,
    control,
    errors,
    dependsOn,
    testId,
    rules
}: OrderEmbeddedSubtitlesSelectorProps): JSX.Element => {
    const { data: embeddedSubtitleLanguages } = useEmbeddedSubtitles();
    const { setEmbeddedSubtitle, embeddedSubtitle, dynamicSubtitles } = useCreateOrder();

    const handleSelectedOption = (id: string) => {
        const currentSubtitle = embeddedSubtitleLanguages?.find((item) => item.id === id);

        if (currentSubtitle) {
            setEmbeddedSubtitle({
                ...currentSubtitle
            });
        }
    };

    const defaultValue = embeddedSubtitle ? embeddedSubtitle.id : CLEAN_VIDEO_SUBTITLE_LANGUAGE_ID;
    control.setValue(name, defaultValue);

    return (
        <FormDropdown
            label={label}
            placeholder="Search and select subtitles"
            name={name}
            options={embeddedSubtitleLanguages?.map((item) => mapToDropdownOption(item)) ?? []}
            control={control}
            errors={errors}
            dependsOn={dependsOn}
            onChange={handleSelectedOption}
            testId={testId}
            rules={rules}
            disabled={!!dynamicSubtitles.length}
            disableClear={true}
        />
    );
};
